import { call, put, takeEvery } from "redux-saga/effects";
import { fetchChatMessagesRequest, fetchChatMessagesSuccess, fetchChatMessagesFailure } from "../slice/chatSlice";
import { fetchChatMessagesApi } from "../../api/apiService";
import axios, { AxiosError } from "axios";

function* fetchChatMessages(action: { payload: { session_id: number | string} }): Generator<any, void, any> {
    try {
        const response = yield call(fetchChatMessagesApi, action.payload);
        yield put(fetchChatMessagesSuccess(response.data));
    } catch (error: unknown) {
        if (error instanceof Error) {
            let errorMessage = "Something went wrong";
            let errorCode: number | undefined;

            if (axios.isAxiosError(error)) {
                const axiosError = error as AxiosError<any>;

                errorMessage =
                    axiosError.response?.data?.message ||
                    axiosError.message ||
                    "API Error";

                errorCode = axiosError.response?.status;
            } else if (error instanceof Error) {
                errorMessage = error.message;
            }
            yield put(fetchChatMessagesFailure({ message: errorMessage, code: errorCode }));
        } else {
            yield put(fetchChatMessagesFailure({message:"An unknown error occurred.", code:-1}));
        }
    }
}

export function* chatSaga() {
    yield takeEvery(fetchChatMessagesRequest, fetchChatMessages);
}
